/**
 * Created by Tiger on 01/03/2022.
 */
import Types from '../types';
import {http} from '../../../common/request';
import {HttpURLS} from '../../../common/http-url-define';
import {formatTimestamp} from '../../../common/util';
import {message} from 'antd';

/**
 * 获取设备列表
 * @param filter
 * @return {(function(*): void)|*}
 */
export function onDeviceList(language, filter) {
  return dispatch => {
    getPrivateDeviceList(dispatch, language, filter);
  };
}

function getPrivateDeviceList(dispatch, language, filter) {
  dispatch({ type: Types.REFRESH_DEVICE_LIST });
  http('get', HttpURLS.DEVICE_URL, filter).then(res => {
    const { code, data } = res.data;
    if (code === 200) {
      console.log('获取设备列表成功：', data, code);
      const { total, devices = [] } = data;
      //test
      // if (process.env.NODE_ENV === 'development') {
      //   total = 200;
      // }
      // const testDevices = generateRandomDeviceData(filter.limit);
      // devices.push(...testDevices);
      //endTest
      let newDevices = [];
      devices.forEach(device => {
        const { mac, product, privateConfig, sendAt, activeAt, createdAt, sn, imei } = device;
        newDevices.push({
          mac,
          name: language.includes('zh') ? product.name : product.en_name,
          configName: privateConfig?.name,
          sendAt: formatTimestamp(sendAt),
          activeAt: formatTimestamp(activeAt),
          createAt: formatTimestamp(createdAt),
          sn,
          imei,
          originalData: device,
        });
      });
      const { offset, limit } = filter;

      dispatch({
        type: Types.REFRESH_DEVICE_LIST_SUCCESS,
        deviceList: newDevices,
        total,
        pageSize: limit,
        currentPage: (offset / limit + 1),
      });
    } else {
      console.error('获取设备列表失败：', data, code);
      dispatch({ type: Types.REFRESH_DEVICE_LIST_FAIL });
    }
  }).catch(error => {
    console.error('获取设备列表失败：', error);
    message.error(error.message);
    dispatch({ type: Types.REFRESH_DEVICE_LIST_FAIL });
  });
}


export function onUpdateDevices(language, data) {
  return dispatch => {
    dispatch({ type: Types.UPDATE_DEVICES });
    http('put', HttpURLS.DEVICE_URL, data)
      .then(res => {
        const { code } = res.data;
        if (code === 200) {
          console.log('更新/新增设备成功：', code, data);
          dispatch({ type: Types.UPDATE_DEVICES_SUCCESS });
          getPrivateDeviceList(dispatch, language, { hadPrivate: true });
        } else {
          console.error('更新/新增设备失败：', code, data);
          dispatch({ type: Types.UPDATE_DEVICES_FAIL });
        }
      }).catch(err => {
      console.error('更新/新增设备失败：', err, data);
    });
  };
}

export function onDeleteDevice(macList) {
  return dispatch => {
  };

}

export function onRefreshNotPrivateDevices(language, filter) {
  return dispatch => {
    dispatch({ type: Types.REFRESH_NOT_PRIVATE_LIST });
    http('get', HttpURLS.DEVICE_URL, filter)
      .then(async res => {
        const { data, code } = res.data;
        if (code === 200) {
          console.log('获取未私有化设备成功：', data);
          let { total, devices } = data;
          const newDevices = [];
          await devices.forEach(device => {
            const { mac, product, createdAt, fromApp, sn, imei  } = device;
            newDevices.push({
              sn,
              imei,
              mac,
              name: language.includes('zh') ? product.name : product.en_name,
              fromApp: language.includes('zh') ? fromApp?.name : fromApp?.enName,
              createAt: formatTimestamp(createdAt),
              originalData: device,
            });
          });
          const { limit = 50, offset = 0 } = filter;
          dispatch({
            type: Types.REFRESH_NOT_PRIVATE_LIST_SUCCESS,
            notPrivateDeviceList: newDevices,
            notPrivateDeviceListTotal: total,
            notPrivateDeviceListPageSize: limit,
            notPrivateDeviceListCurrentPage: (offset / limit + 1),
          });
        } else {
          console.log('获取未私有化设备失败：', res.data);
          dispatch({ type: Types.REFRESH_NOT_PRIVATE_LIST_FAIL });
        }
      }).catch(err => {
      console.error('获取未私有化设备失败：', err);
      dispatch({ type: Types.REFRESH_NOT_PRIVATE_LIST_FAIL });
    });
  };
}
